<div class="row">
  <div class="col-md-10 h-100 ">
    <i (click)="changeLanguage('en')" class="fi fi-us align-middle brand" ></i>&nbsp;
    <i (click)="changeLanguage('pt-br')" class="fi fi-br align-middle brand"></i>&nbsp;
    <i (click)="changeLanguage('es')" class="fi fi-es align-middle brand" ></i>&nbsp;
  </div>
  <div class="col-md-2">
    <div class="input-group mb-3 float-end">
      <input type="text" class="form-control" (keyup.enter)="search(searchId)" [(ngModel)]="searchId" [disabled]="isLoading" placeholder="{{'Buscar' | translate}}">
      <button class="btn btn-outline-secondary" (click)="search(searchId)" type="button" id="button-addon2">
        <span class="spinner-border spinner-border-sm" *ngIf="isLoading" role="status" aria-hidden="true"></span>
        <i class="fa fa-search" *ngIf="!isLoading"></i>
      </button>
    </div>
  </div>
</div>